import {
  Activity,
  Brain,
  CalendarCheck,
  FileDown,
  Gauge,
  LayoutDashboard,
  Lightbulb,
  Receipt,
  Ruler,
  ShieldCheck,
  Bot,
  LandPlot
} from "lucide-react";
import { FormattedMessage } from "react-intl";

const dashboard = (
  <FormattedMessage id="Dashboard" defaultMessage="Escritorio" />
);
const powerSystemMonitoring = "Monitoreo del sistema eléctrico";
const measurement = (
  <FormattedMessage id="Measurement" defaultMessage="Mediciones" />
);
let consumption = (
  <FormattedMessage id="Consumption" defaultMessage="Consumos" />
);
let evolution = <FormattedMessage id="Evolution" defaultMessage="Evolución" />;
let confort = <FormattedMessage id="Confort" defaultMessage="Conforte" />;
let maximetro = <FormattedMessage id="Maximetro" defaultMessage="Maxímetro" />;
let perDevice = (
  <FormattedMessage id="PerDevice" defaultMessage="Por dispositivo" />
);
const costs = <FormattedMessage id="Costs" defaultMessage="Costos" />;
const analysis = <FormattedMessage id="Analysis" defaultMessage="Análisis" />;
const reports = <FormattedMessage id="Reports" defaultMessage="Reportes" />;
const plants = <FormattedMessage id="Plants" defaultMessage="Plantas" />;
const improvementprojects = (
  <FormattedMessage
    id="ImprovementProjects"
    defaultMessage="Proyectos de mejoras"
  />
);
const projectmonitoring = (
  <FormattedMessage
    id="ProjectMonitoring"
    defaultMessage="Monitorización de proyectos"
  />
);
const analytics = <FormattedMessage id="Analytics" defaultMessage="Análisis" />;
const energyMatrix = (
  <FormattedMessage
    id="analysis/energy-matrix"
    defaultMessage="Matriz energética"
  />
);
const reactive = (
  <FormattedMessage id="analysis/reactive" defaultMessage="Reactiva" />
);
const linearRegression = (
  <FormattedMessage id="analysis/linear-regression" defaultMessage="Regresión lineal" />
);
const heatMap = (
  <FormattedMessage id="analysis/heatmap" defaultMessage="Mapa de calor" />
);
const passiveLoads = (
  <FormattedMessage
    id="analysis/passive-load"
    defaultMessage="Cargas pasivas"
  />
);
const loadDemand = (
  <FormattedMessage
    id="analysis/demandedLoaded"
    defaultMessage="Demanda de carga"
  />
);
const solar = <FormattedMessage id="Solar" defaultMessage="Solar" />;
const eolic = <FormattedMessage id="Eolic" defaultMessage="Eólico" />;
const advancedAnalytics = (
  <FormattedMessage id="AdvancedAnalytics" defaultMessage="Análisis avanzado" />
);
const consumosycostos = (
  <FormattedMessage id="consumosycostos" defaultMessage="Consumos y costos" />
);
const suppliers = (
  <FormattedMessage id="ebm/suppliers" defaultMessage="Proveedores" />
);
const uploadBill = (
  <FormattedMessage id="ebm/uploadBill" defaultMessage="Cargar factura" />
);
const insights = (
  <FormattedMessage id="ebm/insights" defaultMessage="Informes" />
);
const healthSafety = (
  <FormattedMessage id="Ing-hys" defaultMessage="Ingeniería + H & S" />
);
const tableros = (
  <FormattedMessage id="ebm/billsData" defaultMessage="Tableros" />
);
const projects = <FormattedMessage id="/projects" defaultMessage="Proyectos" />;
const agent = <FormattedMessage id="Agent" defaultMessage="Agente" />;
const agentRecommendations = (
  <FormattedMessage
    id="master/agent-recommendations"
    defaultMessage="Recomendaciones"
  />
);
const agentDocuments = (
  <FormattedMessage id="master/agent-documents" defaultMessage="Documentos" />
);
const recommendations = (
  <FormattedMessage id="Recommendations" defaultMessage="Recomendaciones" />
);
const agentRecommendationsSection = {
  name: agent,
  icon: <Bot />,
  title: "Agente",
  subAdd: [agentRecommendations],
};
const agentRecommendationsAndDocumentsSection = {
  ...agentRecommendationsSection,
  subAdd: [agentRecommendations, agentDocuments],
};
const additionalPages = (
  <FormattedMessage id="additionalpages" defaultMessage="Paginas adicionales" />
);

export const menuItemAdm = [
  {
    path: "/",
    name: dashboard,
    icon: <LayoutDashboard />,
    title: "Escritorio",
  },
  {
    name: measurement,
    icon: <Gauge />,
    subAdd: [consumption, evolution, confort, maximetro, perDevice],
    title: "Mediciones",
  },
  {
    name: consumosycostos,
    icon: <Receipt />,
    title: "Consumos y Costos",
    shortTitle: "Costos",
    subAdd: [
      // suppliers,
      // uploadBill,
      tableros,
    ],
  },

  {
    name: analysis,
    icon: <Ruler />,
    title: "Análisis",
    subAdd: [
      //     analytics,
      //     energyMatrix,
      reactive,
      // linearRegression,
      heatMap,
      passiveLoads,
      loadDemand,
      //     solar,
      //     eolic,
      //     advancedAnalytics,
    ],
  },
  {
    path: "/reports",
    name: reports,
    title: "Reportes",
    icon: <FileDown />,
  },
  // {
  //   path: "/plant",
  //   name: plants,
  //   icon: <FaIndustry />,
  // },
  {
    path: "/insights",
    name: insights,
    title: "Informes",
    icon: <Brain />,
  },
  {
    path: "/health-safety",
    name: healthSafety,
    icon: <ShieldCheck />,
    title: "Ingeniería + H & S",
    shortTitle: "Ing + H & S",
  },
  {
    path: "/power-system-monitoring",
    name: powerSystemMonitoring,
    icon: <Activity />,
    title: powerSystemMonitoring,
  },
  {
    path: "/improvement-projects",
    name: improvementprojects,
    icon: <CalendarCheck />,
    title: "Proyectos de mejora",
  },
  agentRecommendationsSection,
  { path: '/plan-3d', name: <span>Plano interactivo 3D</span>, title: 'Plano interactivo 3D', icon: <LandPlot /> },
  // {
  //   path: "/project-monitoring",
  //   name: projectmonitoring,
  //   icon: <FaProjectDiagram />,
  // },
];

export const menuItemUser = [
  {
    path: "/",
    name: dashboard,
    title: "Escritorio",
    icon: <LayoutDashboard />,
  },
  {
    name: measurement,
    icon: <Gauge />,
    title: "Mediciones",
    subAdd: [consumption, evolution, confort, maximetro, perDevice],
  },
  {
    name: consumosycostos,
    icon: <Receipt />,
    title: "Consumos y Costos",
    shortTitle: "Costos",
    subAdd: [
      // suppliers,
      // uploadBill,
      tableros,
    ],
  },
  {
    name: analysis,
    icon: <Ruler />,
    title: "Análisis",
    subAdd: [
      //     analytics,
      //     energyMatrix,
      reactive,
      // linearRegression,
      heatMap,
      //     passiveLoads,
      loadDemand,
      //     solar,
      //     eolic,
      //     advancedAnalytics,
    ],
  },
  {
    path: "/reports",
    name: reports,
    title: "Reportes",
    icon: <FileDown />,
  },
  {
    path: "/insights",
    name: insights,
    title: "Informes",
    icon: <Brain />,
  },
  {
    path: "/health-safety",
    name: healthSafety,
    title: "Ingeniería + H & S",
    shortTitle: "Ing + H & S",
    icon: <ShieldCheck />,
  },
  {
    path: "/power-system-monitoring",
    name: powerSystemMonitoring,
    icon: <Activity />,
    title: powerSystemMonitoring,
  },
  {
    path: "/improvement-projects",
    name: improvementprojects,
    icon: <CalendarCheck />,
    title: "Proyectos de mejora",
  },
  agentRecommendationsSection,
  { path: '/plan-3d', name: <span>Plano interactivo 3D</span>, title: 'Plano interactivo 3D', icon: <LandPlot /> },
];

export const menuItemMaster = [
  {
    path: "/",
    name: dashboard,
    title: "Escritorio",
    icon: <LayoutDashboard />,
  },
  {
    name: measurement,
    title: "Mediciones",
    icon: <Gauge />,
    subAdd: [consumption, evolution, confort, maximetro, perDevice],
  },
  {
    name: consumosycostos,
    title: "Consumos y Costos",
    shortTitle: "Costos",
    icon: <Receipt />,
    subAdd: [tableros, suppliers, uploadBill],
  },

  {
    name: analysis,
    icon: <Ruler />,
    title: "Análisis",
    subAdd: [
      //     analytics,
      energyMatrix,
      reactive,
      // linearRegression,
      heatMap,
      //     passiveLoads,
      loadDemand,
      passiveLoads,
      //     loadDemand,
      //     solar,
      //     eolic,
      //     advancedAnalytics,
    ],
  },
  {
    path: "/reports",
    name: reports,
    title: "Reportes",
    icon: <FileDown />,
  },
  {
    path: "/insights",
    name: insights,
    title: "Informes",
    icon: <Brain />,
  },
  {
    path: "/health-safety",
    name: healthSafety,
    title: "Ingeniería + H & S",
    shortTitle: "Ing + H & S",
    icon: <ShieldCheck />,
  },
  {
    path: "/power-system-monitoring",
    name: powerSystemMonitoring,
    icon: <Activity />,
    title: powerSystemMonitoring,
  },
  {
    path: "/improvement-projects",
    name: improvementprojects,
    icon: <CalendarCheck />,
    title: "Proyectos de mejora",
  },
  {
    name: agent,
    icon: <Bot />,
    title: "Agente",
    subAdd: agentRecommendationsAndDocumentsSection.subAdd,
  },
  {
    path: "/plan-3d",
    name: <span>Plano interactivo 3D</span>,
    title: "Plano interactivo 3D",
    icon: <LandPlot />,
  },
  // {
  //   name: additionalPages,
  //   icon: <FaBug />,
  //   subAdd: [projects],
  // },
];
